var map = {
	"./add.svg": "57a0",
	"./add2.svg": "f765",
	"./icon-area.svg": "f6e0",
	"./icon-close.svg": "22df",
	"./icon-demand.svg": "faf9",
	"./icon-painspot.svg": "523b",
	"./icon-result.svg": "7ebe",
	"./icon-sence.svg": "d980",
	"./update.svg": "2765",
	"./update2.svg": "0189"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fc05";